<template>
<div class="softwareUpgrade">
    <div class="upgrade">
      <div class="upgradeRecord">
          <div class="upgradeRecordTit">升级记录</div>
          <!-- <div class="upgradeSelect">
              <el-select v-model="value" filterable placeholder="请选择">
                  <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                  </el-option>
              </el-select>
          </div> -->
      </div>
      
      <div class="upgradeBtn">
          <el-button class="upgrade_btn" @click="dialogFormVisible = true">升级</el-button>
          <el-dialog title="升级" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
            <el-form :model="form">
              <el-form-item label="文件:">
                  <!-- :label-width="formLabelWidth" -->
                <el-input v-model="form.name" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="类型:">
                <el-select v-model="form.region" placeholder="请选择类型">
                  <el-option label="类型一" value=0></el-option>
                  <el-option label="类型二" value=2></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="版本号:">
                <el-input v-model="form.name" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="说明:">
                <el-input type="textarea" v-model="form.desc"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
            </div>
          </el-dialog>
      </div>
    </div>
        
    <div class="table">
        <el-table
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column
            prop="name"
            label="名称"
            width="auto">
            </el-table-column>
            <el-table-column
            prop="type"
            label="版本号"
            width="auto">
            </el-table-column>
            <el-table-column
            prop="explain"
            label="说明"
            width="auto">
            </el-table-column>
            <el-table-column
            prop="upgradePersonnel"
            label="升级人员"
            width="auto">
            </el-table-column>
            <el-table-column
            prop="time"
            label="时间"
            width="auto">
            </el-table-column>
        </el-table>
    </div>
</div>
</template>

<script>
  export default {
    data() {
      return {
        //选择
        options: [{
          value: 1,
          label: '配置系统'
        }],
        value: '配置系统',
        
        //form表单
        dialogFormVisible: false,
        form: {
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        },

        //表格
        tableData: [{
          name: '王小虎',
          type: '工地系统',
          explain: '无法启动',
          upgradePersonnel: '朱朱',
          time: '2016-05-02 19:05',
        }]
      }
    }
  }
</script>

<style scoped>
.softwareUpgrade{
    width: 100%;
    height: 92%;
}
.upgradeRecord{
    width: 20%;
    display: flex;
    height: 100%;
    align-items: center;
    /* background: saddlebrown; */
    justify-content: space-between;
    font-weight: bold;
    font-family: 'Courier New', Courier, monospace;
    font-family: '黑体';
    font-size: 16px;
}
.upgrade{
    width: 100%;
    height: 8%;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 10px 10px 0 0;
    justify-content: space-between;
}
.upgradeRecordTit{
    margin-left: 20px;
    font-family: "黑体";
}
.upgrade_btn{
    background: #455AF7;
    color: #fff;
}
.upgradeBtn{
    margin-right: 20px;
}

.table{
    width: 100%;
}
.table >>> .el-table td,
.table >>> .el-table th {
  text-align: center !important;
}
.table >>> th{
  background: #F2F3F7;
}

/* 弹出框 */
.upgradeBtn >>> .el-dialog{
  width: 40%;
  background:  #F2F3F7;
}
.upgradeBtn >>> .el-dialog__header{
  display: flex;
  justify-content: center;
  font-weight: bold;
  background: #fff;
  
}
.upgradeBtn >>> .el-dialog__body{
  padding: 15px 15px 0 15px!important;
}
.el-form{
  background: #fff;
  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.upgradeBtn >>> .el-dialog__footer{
  /* background: #fff; */
  padding: 0 15px 15px 15px!important;
  
}
.el-form-item{
  width: 85%;
}
.upgradeBtn >>> .el-select{
  width: 100%;
}
.upgradeBtn >>> .el-form-item__content{
  margin-left: 80px;
}
.dialog-footer{
  background: #fff;
  padding: 10px ;
}
</style>


// WEBPACK FOOTER //
// src/pages/Home/softwareUpgrade/index.vue